<div class="sidenav">
  <div class="sidenav__header">
    <picture>
      <source srcset="/assets/logo_dark.svg" media="(prefers-color-scheme: dark)" />
      <img src="/assets/logo_light.svg" height="160" alt="Norwegian Polar Insitute" />
    </picture>
  </div>

  <div class="sidenav__content">
    <mat-nav-list>
      <a
        mat-list-item
        routerLink="/dataset"
        [activated]="isActive('/dataset') || currentRoute() === '/'"
      >
        Datasets
      </a>

      <ng-container
        [ngTemplateOutlet]="expandable"
        [ngTemplateOutletContext]="{
          signal: isArchivesExpanded,
          active: isActive('/map', '/geology', '/vessel'),
          title: 'Archives',
        }"
      />
      @if (isArchivesExpanded()) {
        <mat-nav-list class="nested-list">
          @if (mapArchiveId && mapArchiveId !== '') {
            <a mat-list-item routerLink="/map/archive" [activated]="isActive('/map/archive')">
              Maps
            </a>
          }
          @if (geologicalSampleDatasetId && geologicalSampleDatasetId !== '') {
            <a mat-list-item routerLink="/geology/sample" [activated]="isActive('/geology/sample')">
              Geological samples
            </a>
          }
          @if (vesselDatasetId && vesselDatasetId !== '') {
            <a
              mat-list-item
              routerLink="/vessel"
              title="Kjell-G. Kjær’s Historic Register of Arctic Vessels"
              [activated]="currentRoute().startsWith('/vessel')"
            >
              Historic Arctic vessels
            </a>
          }
        </mat-nav-list>
      }

      <ng-container
        [ngTemplateOutlet]="expandable"
        [ngTemplateOutletContext]="{
          signal: isPlacenamesExpanded,
          active: isActive('/placename'),
          title: 'Placenames',
        }"
      />
      @if (isPlacenamesExpanded()) {
        <mat-nav-list class="nested-list">
          <a
            mat-list-item
            routerLink="/placename"
            [activated]="isActive('/placename') && !isActive('/placename/case')"
          >
            Placenames
          </a>
          <a mat-list-item routerLink="/placename/case" [activated]="isActive('/placename/case')">
            Cases
          </a>
        </mat-nav-list>
      }

      <ng-container
        [ngTemplateOutlet]="expandable"
        [ngTemplateOutletContext]="{
          signal: isPlanktonExpanded,
          active: isActive('/plankton'),
          title: 'Plankton',
        }"
      />
      @if (isPlanktonExpanded()) {
        <mat-nav-list class="nested-list">
          <a
            mat-list-item
            routerLink="/plankton/expedition"
            [activated]="isActive('/plankton/expedition')"
          >
            Expeditions
          </a>
          <a mat-list-item routerLink="/plankton/event" [activated]="isActive('/plankton/event')">
            Events
          </a>
          <a
            mat-list-item
            routerLink="/plankton/occurrence"
            [activated]="isActive('/plankton/occurrence')"
          >
            Occurrences
          </a>
          <a mat-list-item routerLink="/plankton/taxon" [activated]="isActive('/plankton/taxon')">
            Taxa
          </a>
          @if (authService.user(); as user) {
            @if (user.accessLevel === 'admin') {
              <a
                mat-list-item
                routerLink="/plankton/origin"
                [activated]="isActive('/plankton/origin')"
              >
                Imports
              </a>
            }
          }
        </mat-nav-list>
      }

      <ng-container
        [ngTemplateOutlet]="expandable"
        [ngTemplateOutletContext]="{
          signal: isGeodataExpanded,
          active: isActive('/geodata') && !isActive('/geodata/api'),
          title: 'Map data and services',
        }"
      />
      @if (isGeodataExpanded()) {
        <mat-nav-list class="nested-list">
          <a mat-list-item routerLink="/geodata" [activated]="currentRoute() === '/geodata'"
            >Map viewers</a
          >
          <a
            mat-list-item
            routerLink="/geodata"
            fragment="data"
            [activated]="isActive('/geodata#data')"
            >Basemap data</a
          >
          <a
            mat-list-item
            routerLink="/geodata"
            fragment="basemap"
            [activated]="isActive('/geodata#basemap')"
          >
            Basemap services
          </a>
          <a
            mat-list-item
            routerLink="/geodata"
            fragment="thematic"
            [activated]="isActive('/geodata#thematic')"
          >
            Thematic map services
          </a>
          <a
            mat-list-item
            routerLink="/geodata"
            fragment="terms"
            [activated]="isActive('/geodata#terms')"
          >
            Terms of use
          </a>
        </mat-nav-list>
      }

      @if (authService.user(); as user) {
        @if (user.accessLevel === 'admin') {
          <ng-container
            [ngTemplateOutlet]="expandable"
            [ngTemplateOutletContext]="{
              signal: isAdminExpanded,
              active: isActive('/label', '/user', '/role', '/token'),
              title: 'Administration',
            }"
          />
          @if (isAdminExpanded()) {
            <mat-nav-list class="nested-list">
              <a mat-list-item routerLink="/label" [activated]="isActive('/label')"> Labels </a>
              <a mat-list-item routerLink="/user" [activated]="isActive('/user')"> Users </a>
              <a mat-list-item routerLink="/role" [activated]="isActive('/role')"> Roles </a>
              <a mat-list-item routerLink="/token" [activated]="isActive('/token')">
                Application tokens
              </a>
            </mat-nav-list>
          }
        }
      }

      <ng-container
        [ngTemplateOutlet]="expandable"
        [ngTemplateOutletContext]="{
          signal: isTrollExpanded,
          active: isActive('/troll'),
          title: 'Troll weather data',
        }"
        />
      @if (isTrollExpanded()) {
      <mat-nav-list class="nested-list">
        <a mat-list-item routerLink="/troll/station" [activated]="isActive('/troll/station')">Research station</a>
        <a mat-list-item routerLink="/troll/airfield" [activated]="isActive('/troll/airfield')">Airfield</a>
      </mat-nav-list>
      }

      <a mat-list-item routerLink="/kph" [activated]="isActive('/kph')"> RV Kronprins Haakon </a>
      <a mat-list-item routerLink="/about" [activated]="isActive('/about')"> About </a>

      <mat-divider style="margin: 1em 0" />

      <ng-container
        [ngTemplateOutlet]="expandable"
        [ngTemplateOutletContext]="{
          signal: isLinksExpanded,
          title: 'Links',
        }"
      />
      @if (isLinksExpanded()) {
        <mat-nav-list class="nested-list">
          <a
            mat-list-item
            target="_blank"
            href="https://www.npolar.no/"
            rel="nofollow"
            title="Homepage of the Norwegian Polar Institute."
          >
            <span matListItemMeta><mat-icon>open_in_new</mat-icon></span>
            <span matListItemTitle>Norwegian Polar Institute</span>
          </a>
          <a
            mat-list-item
            target="_blank"
            href="https://svalbardkartet.npolar.no/"
            rel="nofollow"
            title="Svalbard map viewer with various thematic map layers available."
          >
            <span matListItemMeta><mat-icon>open_in_new</mat-icon></span>
            <span matListItemTitle>Svalbard thematic maps</span>
          </a>
          <a
            mat-list-item
            target="_blank"
            href="https://topoSvalbard.npolar.no/"
            rel="nofollow"
            title="Topographic map viewer for Svalbard."
          >
            <span matListItemMeta><mat-icon>open_in_new</mat-icon></span>
            <span matListItemTitle>Svalbard topographic map</span>
          </a>
          <a
            mat-list-item
            target="_blank"
            href="https://topoJanMayen.npolar.no/"
            rel="nofollow"
            title="Topographic map viewer for Jan Mayen."
          >
            <span matListItemMeta><mat-icon>open_in_new</mat-icon></span>
            <span matListItemTitle>Jan Mayen topographic map</span>
          </a>
          <a
            mat-list-item
            target="_blank"
            href="https://mosj.no/en/"
            rel="nofollow"
            title="Environmental monitoring information for Svalbard &amp; Jan Mayen."
          >
            <span matListItemMeta><mat-icon>open_in_new</mat-icon></span>
            <span matListItemTitle>MOSJ (environmental monitoring)</span>
          </a>
        </mat-nav-list>
      }

      <ng-container
        [ngTemplateOutlet]="expandable"
        [ngTemplateOutletContext]="{
          signal: isResourcesExpanded,
          active: isActive('/geodata/api'),
          title: 'Developer resources',
        }"
      />
      @if (isResourcesExpanded()) {
        <mat-nav-list class="nested-list">
          <a mat-list-item target="_blank" href="https://docs.data.npolar.no/api/" rel="nofollow">
            <span matListItemMeta><mat-icon>open_in_new</mat-icon></span>
            Swagger</a
          >
          @if (authService.user()?.accessLevel === 'admin') {
            <a mat-list-item target="_blank" href="https://app.npolar.no/grafana/" rel="nofollow">
              <span matListItemMeta><mat-icon>open_in_new</mat-icon></span>
              Grafana</a
            >
          }
          <a mat-list-item target="_blank" href="https://oai.data.npolar.no/oai-pmh/?verb=Identify">
            <span matListItemMeta><mat-icon>open_in_new</mat-icon></span>
            <span matListItemTitle>OAI-PMH API</span>
          </a>
        </mat-nav-list>
      }
      <a mat-list-item target="_blank" href="https://docs.data.npolar.no/">
        <span matListItemMeta><mat-icon>open_in_new</mat-icon></span>
        <span matListItemTitle>Help</span>
      </a>

      <ng-template #expandable let-signal="signal" let-title="title" let-active="active">
        <a
          mat-list-item
          href="#"
          [activated]="!signal() && active"
          (click)="$event.preventDefault(); signal.set(!signal())"
        >
          <span matListItemTitle>{{ title }}</span>
          <span matListItemMeta>
            @if (!signal()) {
              <mat-icon>keyboard_arrow_down</mat-icon>
            } @else {
              <mat-icon>keyboard_arrow_up</mat-icon>
            }
          </span>
        </a>
        @if (signal()) {
          <ng-content />
        }
      </ng-template>
    </mat-nav-list>
  </div>

  <div class="sidenav__footer">
    @if (authService.user(); as user) {
      <div class="account">
        <mat-icon>account_circle</mat-icon>
        <span>{{ user.email }}</span>
        <strong>{{ user.accessLevel }}</strong>
        <p>
          <button mat-button (click)="authService.logout()">
            <mat-icon>logout</mat-icon>Log out
          </button>
        </p>
      </div>
    } @else {
      <p>
        <button mat-button (click)="openLoginDialog()"><mat-icon>login</mat-icon>Log in</button>
      </p>
    }
  </div>
</div>
